function initDynamicScriptLoad() {
    document.querySelectorAll('[data-script]').forEach(function(element) {
        let script = document.createElement('script');
        script.src = element.getAttribute('data-script');
        script.async = true;
        script.defer = true;
        document.body.append(script);
    });
}

function setupDynamicScriptLoad() {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            initDynamicScriptLoad();
        })
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupDynamicScriptLoad);
} else {
    setupDynamicScriptLoad();
}